import React, { useState, useCallback, useEffect } from "react";
import {
  Card,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import dialogBgImage from "assets/images/dialogBgImage.png";
import { useMediaQuery } from "react-responsive";
import { IconButton, InputAdornment } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import TelegramIcon from "@mui/icons-material/Telegram";
import CloseIcon from "@mui/icons-material/Close";
import TwitterIcon from "@mui/icons-material/Twitter";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";

function ShareDialog({ openStatus, onClose, postId, type }) {
  let navigate = useNavigate();

  const [shareUrl, setShareUrl] = useState("");

  //   const shareUrl = `https://app.singhcoin.io/post-details/?p_source=${postId}`; not for use
  //   const shareUrl = `https://new-demo.singhcoin.io/post-details/?p_source=${postId}`; not for use

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const handleCopy = () => {
    toast.success(`Copied to clipboard`, {
      style: {
        fontSize: "15px",
      },
    });
  };

  useEffect(() => {
    checkType();
  }, []);

  const checkType = () => {
    if (type === "nft") {
      setShareUrl(
        `https://app.singhcoin.io/auction-details/?auctionId=${postId}`
      );
    } else {
      setShareUrl(`https://app.singhcoin.io/post-details/?p_source=${postId}`);
    }
  };

  return (
    <Dialog
      sx={{}}
      open={openStatus}
      maxWidth="sm"
      fullWidth
      fullScreen={isTabletOrMobile && true}
      onClose={onClose}
    >
      <MDBox
        sx={{
          //   overflow: "auto",
          height: isTabletOrMobile && "1000px",
          border: isDesktopOrLaptop && "1px solid #F2CB2E",
          borderRadius: isDesktopOrLaptop && "8px",
          backgroundColor: "#1a1a1a",
          // backgroundImage: `url(${dialogBgImage})`,
          // backgroundRepeat: "no-repeat",
          // backgroundSize: "cover",
          // objectFit: "cover",
          // backgroundPosition: isTabletOrMobile && "bottom",
        }}
      >
        <DialogTitle sx={{}}>
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MDTypography>Share</MDTypography>

            <IconButton onClick={onClose}>
              <MDTypography>
                <CloseIcon />
              </MDTypography>
            </IconButton>
          </MDBox>
        </DialogTitle>
        <DialogContent sx={{}}>
          <MDBox
            sx={{
              width: "80%",
              margin: "auto",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <IconButton
              onClick={() => {
                const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                  shareUrl
                )}`;
                window.open(facebookLink, "_blank");
              }}
            >
              <MDTypography fontSize="50px">
                <FacebookIcon />
              </MDTypography>
            </IconButton>
            {/* <IconButton
              onClick={() => {
                window.open(
                  `https://www.instagram.com/share?url=${encodeURIComponent(
                    shareUrl
                  )}`,
                  "_blank"
                );
              }}
            >
              <MDTypography fontSize="50px">
                <InstagramIcon />
              </MDTypography>
            </IconButton> */}
            <IconButton
              onClick={() => {
                const telegramLink = `https://t.me/share/url?url=${encodeURIComponent(
                  shareUrl
                )}`;
                window.open(telegramLink, "_blank");
              }}
            >
              <MDTypography fontSize="50px">
                <TelegramIcon />
              </MDTypography>
            </IconButton>
            <IconButton
              onClick={() => {
                const twitterLink = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
                  shareUrl
                )}`;
                window.open(twitterLink, "_blank");
              }}
            >
              <MDTypography fontSize="50px">
                <TwitterIcon />
              </MDTypography>
            </IconButton>
          </MDBox>
          <MDBox
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
              border: "1px solid #F2CB2E",
              padding: "1rem",
              borderRadius: "20px",
            }}
          >
            <MDBox
              sx={{
                width: isTabletOrMobile ? "250px" : "400px",
              }}
            >
              <MDTypography
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                fontSize="15px"
              >
                {shareUrl}
              </MDTypography>
            </MDBox>
            <MDBox>
              <CopyToClipboard text={shareUrl}>
                <MDButton size="small" color="singh" onClick={handleCopy}>
                  Copy
                </MDButton>
              </CopyToClipboard>
            </MDBox>
          </MDBox>
        </DialogContent>
      </MDBox>
    </Dialog>
  );
}

export default ShareDialog;
